import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVDate } from "../../shared/JVDate";

export interface IFilter {
    name?: string;
    fromDate?: Date;
    toDate?: Date;
}

interface Iprops {
    filter: IFilter
    loading: boolean
    header: any
    setFilter: (filter: IFilter) => void
}

export const Filter = (props: Iprops) => {
    const { control, handleSubmit, reset } = useForm<IFilter>({
        defaultValues: props.filter
    });

    function onSubmit(data: IFilter) {
        props.setFilter(data);
    }

    const clear = () => {
        const resetData: IFilter = {
            fromDate: new Date(),
            toDate: new Date(),
            // name: ""
        };

        reset(resetData);
        props.setFilter(resetData);
    };

    return (
        <Accordion>
            <AccordionTab header={props.header}>

                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid grid">
                    {/* <div className="col-12 md:col-4">
                        <label>Name</label>
                        <input
                            className="p-inputtext p-component w-full"
                            value={props.filter.name || ""}
                            onChange={(e) =>
                                props.setFilter({ ...props.filter, name: e.target.value })
                            }
                        />
                    </div> */}

                    <JVDate
                        column={4}
                        label="From Date"
                        control={control}
                        name="fromDate"
                    />

                    <JVDate
                        column={4}
                        label="To Date"
                        control={control}
                        name="toDate"
                    />

                    {/* <div className="col-12 flex gap-3 mt-3">

                        <Button
                            label="Search"
                            type="submit"
                            loading={props.loading}
                        />

                        <Button
                            label="Clear"
                            type="button"
                            onClick={clear}
                            className="p-button-outlined"
                        />

                    </div> */}
                    <div className="col-12 flex justify-content-end gap-2 mt-3">

                        <Button
                            label="Search"
                            type="submit"
                            loading={props.loading}
                            className="p-button-sm p-button-rounded"
                            style={{ width: "90px", height: "32px" }}
                        />

                        <Button
                            label="Clear"
                            type="button"
                            onClick={clear}
                            className="p-button-sm p-button-rounded p-button-outlined"
                            style={{ width: "90px", height: "32px" }}
                        />

                    </div>
                </form>

            </AccordionTab>
        </Accordion>
    );
};